// extracted by mini-css-extract-plugin
export default {"button":"XgxzXJUVNXB_0zQOWuRZ"};